import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  y?: number;
}
export function Reveal({
  children,
  delay = 0,
  className,
  y = 24
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.16, 1, 0.3, 1]
  }} data-id="element-285" data-mp="yf9sk28oehil">
      {children}
    </motion.div>;
}
interface EyebrowProps {
  children: React.ReactNode;
  className?: string;
}
export function Eyebrow({
  children,
  className = ''
}: EyebrowProps) {
  return <span className={`inline-flex items-center gap-3 text-xs font-medium uppercase tracking-widest2 text-gold-dark ${className}`} data-id="element-286" data-mp="aqqibh62funv">
      <span className="h-px w-8 bg-gold" aria-hidden="true" data-id="element-287" data-mp="3j4z2q1yfpf4y" />
      {children}
    </span>;
}